module.exports = __webpack_public_path__ + "static/img/yx01.60fee9bf.png";